import script from "./ProfessionalDevelopmentComments.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalDevelopmentComments.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalDevelopmentComments.vue?vue&type=style&index=0&id=34f72810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f72810"]])

export default __exports__